import Text from 'components/Text/Text';
import React, { useContext, useMemo } from 'react';
import { RequestEntity, IItemVideo } from 'types';
import {
	IVideosAssignmentContext,
	VideosAssignmentContext,
} from '../../../../../videosAssignmentState/videosAssignmentContext';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import { Checkbox } from 'antd';
import classNames from 'classnames';
import style from './Video.module.scss';

interface IVideo {
	data: IItemVideo;
}

const Video: React.FC<IVideo> = ({ data }) => {
	const { setIDsSelectedVideos, IDsSelectedVideos } = useContext<IVideosAssignmentContext>(VideosAssignmentContext);
	const checkCheckbox = () => IDsSelectedVideos.includes(data.id);
	const isCheckedCheckbox = useMemo(() => checkCheckbox(), [data, IDsSelectedVideos]);
	const isAssigned = !!data.restaurants.length;

	const containerClasses = classNames(style.container, {
		[style.checkedCheckbox]: isCheckedCheckbox,
		[style.assigned]: isAssigned,
	});

	const handleChange = (value: boolean) => {
		if (value) {
			setIDsSelectedVideos([...IDsSelectedVideos, data.id]);
		} else {
			const updateVideoList = IDsSelectedVideos.filter((el) => el !== data.id);
			setIDsSelectedVideos(updateVideoList);
		}
	};

	return (
		<div className={containerClasses} data-test="Video">
			<div className={style.name}>
				<Checkbox
					className={style.checkbox}
					onChange={(e) => handleChange(e.target.checked)}
					checked={isCheckedCheckbox}
				/>
				<div className={style.imgWrapper}>
					<ImgUploaderByEntityId
						resource={RequestEntity.Videos}
						entityID={data.iconPath ? data.id : ''}
						photoSize="Small"
						loaderSize="small"
						noImageIdIcon="videoDefaultAvatar"
					/>
				</div>
				<Text className={style.videoName} translationKey={data.name} withTooltip={true} />
			</div>
			<div className={style.studio}>
				<Text translationKey={data.videoStudioName} withTooltip={true} />
			</div>
			<div className={style.category}>
				<Text translationKey={data.videoCategoryName} withTooltip={true} />
			</div>
		</div>
	);
};

export default Video;
